// extracted by mini-css-extract-plugin
module.exports = {"wrap":"pagination_wrap__aKp44","tip_text":"pagination_tip_text__GygIP"};